export default "__VITE_ASSET__kY0H_rFV__"